export function uploadFiles(inputFile, imageFile, buttonRemove) {
    const inputSelected = document.querySelectorAll(inputFile);
  
    inputSelected.forEach((input) => {
      input.addEventListener('change', function() {
        let size = this.files[0].size;
        let imageWrapper = this.parentNode.querySelector('.label-wrapper-image');
        let alertActive =  this.parentNode.querySelector('.label-wrapper p');
        let imagePreview = this.parentNode.querySelector(imageFile);
        let imageRemove = this.parentNode.querySelector(buttonRemove);
  
        if(size < 10485760) {
          if (this.files && this.files[0]) {
            let file = new FileReader();
            let imagePlaceholder = imagePreview.src;
  
            file.onload = function(e) {
              imagePreview.src = e.target.result;
              imageRemove.classList.add('d-flex');
            };
  
            imageRemove.addEventListener('click', () => {
              imageRemove.classList.remove('d-flex');
              input.value = "";
              imagePreview.src = imagePlaceholder;
  
              const siblings = document.querySelector(`input[name="${input.id}"]`);
              if(siblings){
                siblings.value = '';
              }
            });
  
            file.readAsDataURL(this.files[0]);
  
            if(alertActive) {
              alertActive.remove();
            }
          }
        } else {
          const alert = `<p>Tamanho não permitido.</p>`;
          imageWrapper.insertAdjacentHTML('beforebegin', alert);
        }
      });
    });
  }
  